<template>
    <div id="wrapper">
        <Director-Bar index="8"></Director-Bar>

        <div id="content-wrapper">
            <div class="container-fluid">
                <b-form-textarea id="textarea" v-model="content" placeholder="Enter something..." rows="3"
                    max-rows="6"></b-form-textarea>
            </div>
            <b-button class="float-right mt-2 mr-3" variant="info" @click="updateNote">Save</b-button>
            <!-- /.container-fluid -->
        </div>
    </div>
</template>

<script>
import axios from "axios";

import DirectorBar from "../Bonus/Bonus_Bar.vue";

export default {
    name: "Roles",
    components: {

        DirectorBar,
    },
    computed: {


    },
    data() {
        return {
            content: "",
        };
    },
    beforeRouteEnter(to, from, next) {
        axios.get("/api/bonus/getNoteBonus").then((response) => {
            next((vm) => vm.initData(response.data));
        });
    },
    methods: {
        initData(content) {
            this.content = content;
        },
        updateNote() {
            const formSubmit = {
                note: this.content,
            };
            axios.post(`/api/bonus/updateNoteBonus`, formSubmit, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                this.$toast.success("Update successfully !", "Successful", {
                    timeout: 3000,
                });
            }).catch((error) => {
                this.$toast.error("Update fail !", "Error", {
                    timeout: 3000,
                });
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>